require('./vendor/jquery.form');

import { appendFormError, validateFormAgreement } from './inc/formUtils';
import { word_limit_tiny } from "./inc/word-limiting";
import tabbedSelect from "./components/tabbedSelect";

import { regExpURL } from './utils/regex';

let contributeDropZone;
let articleAnecdotesDropZone;

/* geo location functionality */
let map, latLng;
const articleLocationLatLng = $('#articleLocationLatLng');
const articleLocationAddress = $('#articleLocationAddress');
const preLoader = $('#postsPreLoader');

const contributeToHistoryForm = $("#contributeToHistoryForm");
const nonce = $('[name="_nonce"]', contributeToHistoryForm).val();

const btnAddFiles = $("#btnAddFiles");
const filesAttachmentWrapper = $("#filesAttachmentWrapper");
const contributeFilesWarning = $("#contributeFilesWarning");
const articleAnecdotesAttachment = $("#articleAnecdotesAttachment");
const successSubmitPopup = $("#successSubmitPopup");
const articleAnecdotesHistory = $("#articleAnecdotesHistory");
const cfMessagePopup = $("#cfMessagePopup");
const cfMessagePopupText = cfMessagePopup.find(".popup-text");

const articleDate = {
    day: $("#articleDateDay"),
    month: $("#articleDateMonth"),
    year: $("#articleDateYear")
};

tabbedSelect('#article_source_field', contributeToHistoryForm[0]);

articleLocationAddress.on("keyup input", function () {
    if (articleLocationAddress.val() === "") {
        articleLocationLatLng.val("");
    }
});

latLng = articleLocationLatLng.val();
latLng = ('' !== latLng) ? latLng.substring(1, latLng.length - 1).split(', ') : [55.378051, -3.43597299999999];
latLng = new google.maps.LatLng(latLng[0], latLng[1]);

google.maps.event.addDomListener(window, 'load', function () {
    var autoComplete = new google.maps.places.Autocomplete(document.getElementById('articleLocationAddress'));
    google.maps.event.addListener(autoComplete, 'place_changed', function () {
        var currentPlace = autoComplete.getPlace();
        if (currentPlace.geometry.location !== null) {
            var latLng = currentPlace.geometry.location;
            /*map.setCenter(latLng);
            setGMapMarker(latLng);*/
            articleLocationLatLng.attr('value', latLng);
        }
    });
});
/* end geo location functionality */


cfMessagePopup.find(".popup-close").on("click", function () {
    cfMessagePopup.stop(true, true).fadeOut(500);
    cfMessagePopupText.text("");
});

limitDateField(articleDate.day);
limitDateField(articleDate.month);
limitDateField(articleDate.year);

// limit of tinymce
setTimeout(() => {
    if (!window.hasOwnProperty("tinymce")) {
        return;
    }

    // tinymce.editors['article_anecdotes_history'];

    const editor = tinymce.editors['article_anecdotes_history'];

    if (!editor) {
        return;
    }

    editor.onKeyUp.add(function (ed, l) {
        let content = editor.getContent();
        let new_content = content.replace(/<[a-z0-9]+><\/[a-z0-9]+>/g, " ");
        new_content = new_content.replace(/<[a-z0-9]+>/g, "");
        new_content = new_content.replace(/<\/[a-z0-9]+>/g, "");

        word_limit_tiny(new_content);

        $('textarea#article_anecdotes_history').val(new_content)
    });
}, 1000);


const appendFileSourceData = (file, xhr, formData) => {
    const source = $(file.previewElement).next(".contribute-form__item-wrap").find("input");
    formData.append('source[' + file.name + ']', source.val());
}

function createDropzoneConfig(args) {
    return $.extend({
        autoDiscover: false,
        url: alexandrian_wicca.ajaxurl,
        withCredentials: true,
        uploadMultiple: true,
        parallelUploads: 10,
        params: {
            action: 'post_creation',
            action_post_creation: 'post_creation_media_attachment',
            _nonce: nonce,
        },
        maxFiles: 10,
        autoProcessQueue: false,
        addRemoveLinks: true,
        acceptedFiles: 'image/*,application/pdf',
        maxFilesize: 32,
        paramName: 'file_attach',
        previewsContainer: "#filesAttachmentWrapper",
    }, args);
}


contributeDropZone = new Dropzone(btnAddFiles[0], createDropzoneConfig({
    maxFilesize: 32,
    maxFiles: 10,
    acceptedFiles: 'image/*,application/pdf',
    previewsContainer: "#filesAttachmentWrapper",
    paramName: 'file_attach',
}));

contributeDropZone.on('addedfile', function (file) {
    var dz = this;

    if (this.files.length) {
        var i, len;
        for (i = 0, len = this.files.length; i < len - 1; i++) {
            if (
                this.files[i].name === file.name &&
                this.files[i].size === file.size &&
                this.files[i].lastModifiedDate.toString() === file.lastModifiedDate.toString()
            ) {
                showContributeToHistoryFormMessagePopup("This file already added");
                //this.removeFile(this.file);
            }
        }
    }
    if ((file.size / 1024) > 32768) {
        this.removeFile(file);
        showContributeToHistoryFormMessagePopup("File size is too big, 32MB max");
    }

    var tpl = $('#tpl-media-src-input').html();

    tpl = $(tpl).attr('data-file', file.name);

    $(file.previewElement).after(tpl);
});

contributeDropZone.on('removedfile', function (file) {
    filesAttachmentWrapper.find(".contribute-form__item-wrap[data-file='" + file.name + "']").remove();
});

contributeDropZone.on('maxfilesexceeded', function (file) {
    var tt;
    clearTimeout(tt);
    this.removeFile(file);
    contributeFilesWarning.addClass("visible");
    tt = setTimeout(function () {
        contributeFilesWarning.removeClass("visible");
    }, 1400);
});

contributeDropZone.on('completemultiple', function (filesUploaded) {
    var uploadStatus = true;
    for (var i = 0; i < filesUploaded.length; i++) {
        if (filesUploaded[i].status !== "success") {
            uploadStatus = false;
        }
    }

    if (uploadStatus !== true) {
        showContributeToHistoryFormMessagePopup("File size is too big, 32MB max");
    }
});

contributeDropZone.on('sending', appendFileSourceData);

articleAnecdotesDropZone = new Dropzone(articleAnecdotesAttachment[0], createDropzoneConfig({
    maxFilesize: 2,
    paramName: 'file_attach_anecdotes',
    maxFiles: 1,
    acceptedFiles: 'image/*,.jpg,.jpeg,.png',
    previewsContainer: "#articleAnecdotesAttachmentWrapper",
}));

window.articleAnecdotesDropZone = articleAnecdotesDropZone;

articleAnecdotesDropZone.on('addedfile', function (file) {
    if ((file.size / 1024) > 2040) {
        this.removeFile(file);
        alert("File size is too big, 2MB max");
    } else {
        $(file.previewElement).after($('#tpl-anecdote-src-input').html());
        articleAnecdotesAttachment.next("span").hide();
        articleAnecdotesAttachment.hide();
    }
});

articleAnecdotesDropZone.on("removedfile", function (file) {
    articleAnecdotesAttachment.next("span").show();
    articleAnecdotesAttachment.show();
    $("#articleAnecdotesAttachmentWrapper .contribute-form__item-wrap").remove();
});

articleAnecdotesDropZone.on('maxfilesexceeded', function (file) {
    this.removeFile(file);
});

articleAnecdotesDropZone.on('complete', function (fileUploaded) {
    if (fileUploaded.status === 'success') {
        if (preLoader.is(":visible")) {
            articleAnecdotesDropZone.removeAllFiles();
        }
    } else {
        alert("There was an errors adding on Contribute your history, try again");
    }
});

articleAnecdotesDropZone.on('sending', appendFileSourceData);


$('.js-add-link-field').on('keyDown', (e) => {
    if (e.keyCode === 13) {
        $(e.currentTarget).closest('[data-add-link-container]').find('.js-add-link-button').trigger('click');
        return false;
    }
});

$('.js-add-link-button').on('click', (e) => {
    e.preventDefault();

    const button = $(e.currentTarget);
    const container = button.closest('[data-add-link-container]');
    const field = $('.js-add-link-field', container).removeClass('error');
    const value = field.val();

    const results = $('.js-added-links-wrapper', container);

    $('span.error', container).remove();

    if (!regExpURL.test(value) || !value.length) {
        appendFormError(container, false, 'Please enter valid URL link');
        field.addClass("error");
        return;
    }

    let tpl = $(container.attr('data-add-link-container')).html();
    tpl = tpl.replace(/__NAME__/g, container.attr('data-name'));
    tpl = tpl.replace(/__VALUE__/g, value);

    container.append(tpl)

    field.val('');
});

$(document).on('click', '.js-remove-added-link', (e) => {
    e.preventDefault();
    $(e.currentTarget).closest('.js-added-links-item').slideUp(function () {$(this).remove()});
})

function validateForm(form) {
    form.find('[required]').each(function (i, field) {
        field = $(field);
        const val = field.val();
        const fieldErrorWrap = field.parent();

        if (!val || val.length === 0 || val === '') {
            field.addClass("error");
            appendFormError(fieldErrorWrap, false, "Please fill in this field");
        }
    });
}

contributeToHistoryForm.find("[required]").each(function (i, field) {
    field = $(field);
    const errorWrap = field.parent();

    field.on("keyup focus input", function () {
        if (field.val() !== '' && (field.hasClass("error") || errorWrap.find(".error").length)) {
            field.removeClass("error");
            errorWrap.find(".error").remove();
        }
    });
});

/* limit anecdotes text words length */
articleAnecdotesHistory.on("keyup input", function (e) {
    const articleAnecdotesHistoryText = articleAnecdotesHistory.val().split(' ');
    if (articleAnecdotesHistoryText.length > 1000) {
        articleAnecdotesHistory.val('');
        articleAnecdotesHistory.val(articleAnecdotesHistoryText.join(' '));
        if (!articleAnecdotesHistory.hasClass("error")) {
            articleAnecdotesHistory.addClass("error");
            appendFormError(articleAnecdotesHistory.closest(".contribute-form__item-wrap"), false, "You may enter maximum 1000 words in this field");
        }
    } else {
        articleAnecdotesHistory.removeClass("error");
        articleAnecdotesHistory.closest(".contribute-form__item-wrap").find("span.error").remove();
    }
});

/* end limit anecdotes text words length */


function contributionIsSuccessful() {
    successSubmitPopup.fadeIn(700);

    contributeToHistoryForm.removeClass('submitting');
    resetContributeToHistoryForm(true, true);

    $('.js-added-links-wrapper').empty();
    $('.js-added-links-item').remove();
    // tinymce.editors['articleAnecdotesHistory'].setContent('');
}

/* contribute to history form submit */
contributeToHistoryForm.on("submit", function (e) {
    e.preventDefault();

    if (contributeToHistoryForm.hasClass('submitting')) {
        return false;
    }

    validateForm(contributeToHistoryForm);
    validateFormAgreement(contributeToHistoryForm);

    const submitErrors = contributeToHistoryForm.find('.error');

    if (submitErrors.length) {
        $('html, body').animate({
            scrollTop: submitErrors.first().position().top
        }, 200, function () {
            submitErrors.first().addClass('highlight-error');
            setTimeout(() => submitErrors.first().removeClass('highlight-error'), 3500);
        });

        return false;
    }

    preLoader.stop(true, true).fadeIn(600);

    contributeToHistoryForm.addClass('submitting');

    contributeToHistoryForm.ajaxSubmit({
        url: alexandrian_wicca.ajaxurl,
        success: (response) => {
            if (contributeDropZone.files.length === 0 && articleAnecdotesDropZone.files.length === 0) {
                return contributionIsSuccessful();
            }

            let dropzoneQueue = [];

            const processQueue = () => {
                if (dropzoneQueue.length) {
                    dropzoneQueue.shift().processQueue();
                } else {
                    contributionIsSuccessful();
                }
            }

            const queue = (zone) => {
                zone.on('queuecomplete', processQueue);
                dropzoneQueue.push(zone)
            }

            contributeDropZone.options.params.post_id = response.post_id;
            articleAnecdotesDropZone.options.params.post_id = response.post_id;

            /* if post creation success upload media attachments */
            if (contributeDropZone.files.length > 0) {
                queue(contributeDropZone)
            }

            if (articleAnecdotesDropZone.files.length > 0) {
                queue(articleAnecdotesDropZone)
            }

            processQueue();
        }
    });

    return false;
});


function resetContributeToHistoryForm(showSuccess, clear_dropzone = false) {
    if (clear_dropzone) {
        contributeDropZone.removeAllFiles();
        articleAnecdotesDropZone.removeAllFiles();
    }

    contributeToHistoryForm.resetForm();

    var articleAnecdotesAttachmentWrapper = $("#articleAnecdotesAttachmentWrapper");
    var anecdoteSection = $("#anecdoteSection");
    var videoURL = $("#videoURL");
    var podcastURL = $("#podcastURL");

    videoURL.attr("data-val", "");
    podcastURL.attr("data-val", "");
    preLoader.stop(true, true).fadeOut(1500, function () {
        if (showSuccess === true) {
            successSubmitPopup.fadeIn(1600);
        }
        contributeToHistoryForm.resetForm();
    });


    anecdoteSection.stop(true, true).slideDown(500);

    contributeToHistoryForm.trigger('change.select2')
    contributeToHistoryForm.find(".video-link-item").remove();
    contributeToHistoryForm.find(".contribute-form__item-wrap .contribute-form__item-wrap").remove();
}

function showContributeToHistoryFormMessagePopup(popupText) {
    const cfMessagePopupText = cfMessagePopup.find(".popup-text");
    cfMessagePopupText.text(popupText);
    cfMessagePopup.stop(true, true).fadeIn(500);
}

function limitDateField(formField) {
    var maxLength = parseInt(formField.attr("maxlength"));
    var max = parseInt(formField.attr("max"));
    var min = parseInt(formField.attr("min"));
    formField.on("input", function () {
        if (formField.val().length > maxLength) {
            formField.val(formField.val().substr(0, maxLength));
        }
        if (parseInt(formField.val()) > max) {
            formField.val(max);
        }
        if (parseInt(formField.val()) < min && formField.attr("name") !== "article_date_year") {
            formField.val(min);
        } else if (formField.attr("name") === "article_date_year" && formField.val().length === 4) {
            if (parseInt(formField.val()) > max) {
                formField.val(max);
            }
            if (parseInt(formField.val()) < min) {
                formField.val(min);
            }
        }
    });
}
